// import { LayoutTitleElement } from '@bts-web/core-features/layouts';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import { AssetType } from '../types';
import { AssetTypeFilters } from '../utils/AssetTypeFilters';
import { getAssetDetailsTranslations } from '../utils/getAssetDetailsTranslations';
import { TFunction } from 'i18next';
import { getAssetById, isEquityAsset } from '../../common';
import { AssetDetailsPageProps } from './AssetDetailByIdIndex';
import { NextPage } from 'next';
import { LayoutTitleElement } from '../../layouts/LayoutWithLeftDesktopNav/AppMainLayoutWrapper/LayoutTitleElement';

export const AssetDetailByIdTitle = async ({
  assetId,
}: {
  assetId: string;
}) => {
  const { t } = await initServerTranslation();

  const assetDetailTranslations = getAssetDetailsTranslations(t as TFunction);

  const { data } = await getAssetById(assetId, true);

  if (!data) {
    return null;
  }

  const { __typename, name, symbol } = data;

  return (
    <LayoutTitleElement
      title={{
        titleType: 'breadcrumbs',
        value: [
          {
            label: assetDetailTranslations[__typename as AssetType],
            href: `/discover?assetType=${encodeURIComponent(
              AssetTypeFilters[__typename as AssetType] ?? '',
            )}`,
          },
          {
            label: (isEquityAsset(__typename) ? symbol : name) ?? '',
          },
        ],
      }}
    />
  );
};

export const AssetDetailByIdIndexTitle: NextPage<
  AssetDetailsPageProps
> = async (props) => {
  const { params } = props;

  const { assetId } = await params;

  return <AssetDetailByIdTitle assetId={assetId} />;
};
